import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_icon = _resolveComponent("file-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_delete_file_btn = _resolveComponent("delete-file-btn")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    clickable: "",
    onClick: _ctx.view
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_file_icon, { "file-name": _ctx.fileName }, null, 8, ["file-name"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.fileName), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { side: "" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (_ctx.canDelete)
              ? (_openBlock(), _createBlock(_component_delete_file_btn, {
                  key: 0,
                  onDeleted: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleted', $event)))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["onClick"]))
}